import { useState } from 'react';
import type { Item } from '@mas-flow/types';

export function AnchorReferencePanel({ allItems, currentItemId }: { allItems: Item[]; currentItemId?: string }) {
  const [open, setOpen] = useState(true);
  const anchors = allItems.filter((i) => i.isAnchor);
  return (
    <section className="rounded border border-amber-200 bg-amber-50 p-3">
      <button type="button" onClick={() => setOpen((v) => !v)} className="flex w-full items-center justify-between text-left">
        <span className="text-xs font-semibold uppercase tracking-wide text-amber-800">
          ⚓ Anchor reference {open ? '▾' : '▸'}
        </span>
        <span className="text-xs text-amber-700">{anchors.length}</span>
      </button>
      {open && (
        anchors.length === 0 ? (
          <p className="mt-2 text-xs italic text-amber-700">No anchors yet — flag a few items to calibrate.</p>
        ) : (
          <ul className="mt-2 space-y-1">
            {anchors.map((a) => (
              <li
                key={a.id}
                className={`text-xs text-slate-700 ${a.id === currentItemId ? '-mx-1 rounded bg-amber-100 px-1 py-0.5' : ''}`}
              >
                <span className="font-medium">{a.title}</span>
                {a.wsjf != null && <span className="ml-2 text-slate-500">WSJF {a.wsjf.toFixed(1)}</span>}
                {a.id === currentItemId && (
                  <span className="ml-2 rounded bg-amber-600 px-1 py-px text-[10px] font-semibold text-white">this item</span>
                )}
                {a.anchorWhy && <div className="text-slate-500">— {a.anchorWhy}</div>}
              </li>
            ))}
          </ul>
        )
      )}
    </section>
  );
}
